import { SxProps, Theme } from "@mui/material";

export default (theme: Theme): Record<string, SxProps<Theme>> => ({
  container: {
    displayPrint: "none",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    p: "calc(2 * var(--rhythm))",
    boxSizing: "border-box",
    [theme.breakpoints.down("md")]: {
      // position: "fixed",
      bottom: 0,
      width: "100%",
      height: "calc(4.5 * var(--rhythm))",
      paddingX: "var(--rhythm)",
      background: "var(--color-primary)",
      zIndex: 1000,
    },
  },

  button: {
    [theme.breakpoints.down("md")]: {
      color: "var(--color-primary)",
      background: "var(--color-white)",
      "&:hover": {
        background: "var(--color-white)",
      },
    },
  },
});
